import { EconomicGroupMemberResponse } from '@interfaces/economic-groups/responses/economic-group.response';

/**
 * Funções puras sobre a árvore de membros do builder do Grupo Econômico. Saíram do
 * `EconomicGroupBuilderComponent` (card 3578) para o componente não crescer com a importação de organograma.
 */

/** Ids de empresa de todos os membros, em profundidade (pode repetir se a árvore repetir). */
export function collectMemberCompanyIds(members: EconomicGroupMemberResponse[]): string[] {
  const ids: string[] = [];
  for (const member of members) {
    ids.push(member.companyId);
    if (member.children?.length) ids.push(...collectMemberCompanyIds(member.children));
  }
  return ids;
}

/** Todos os membros da árvore numa lista, em profundidade. */
export function flattenMembers(
  members: EconomicGroupMemberResponse[]
): EconomicGroupMemberResponse[] {
  const result: EconomicGroupMemberResponse[] = [];
  for (const member of members) {
    result.push(member);
    if (member.children?.length) result.push(...flattenMembers(member.children));
  }
  return result;
}

/** Tira o membro de onde estiver (muta a árvore). `true` se achou. */
export function removeMemberFromTree(
  members: EconomicGroupMemberResponse[],
  memberId: string
): boolean {
  const index = members.findIndex(member => member.id === memberId);
  if (index !== -1) {
    members.splice(index, 1);
    return true;
  }
  return members.some(
    member => !!member.children?.length && removeMemberFromTree(member.children, memberId)
  );
}

/** Quantos membros a árvore tem, contando os filhos. */
export function countMembers(members: EconomicGroupMemberResponse[]): number {
  return members.reduce((sum, member) => sum + 1 + countMembers(member.children ?? []), 0);
}

/** Remove itens repetidos pelo `id`, mantendo o primeiro. */
export function dedupeById<T extends { id: string }>(items: T[]): T[] {
  const seenIds = new Set<string>();
  return items.filter(item => {
    if (seenIds.has(item.id)) return false;
    seenIds.add(item.id);
    return true;
  });
}
